import React, { FC, lazy } from 'react'
import { APG_COLOR_HEX } from '../../../config'
const QRCode = lazy(() => import('react-qrcode-logo').then((module) => ({ default: module.QRCode })))

interface OwnProps {
  value: string
  logoImage?: string
  fgColor?: string
  logoOpacity?: number
  qrStyle?: 'squares' | 'dots'
  ecLevel?: 'L' | 'M' | 'Q' | 'H'
  size?: number
}

const AyrCode: FC<OwnProps> = ({
  value,
  logoImage,
  fgColor = APG_COLOR_HEX,
  logoOpacity = 1,
  qrStyle = 'dots',
  ecLevel = 'L',
  size,
}) => {
  return (
    <QRCode
      value={value}
      logoImage={logoImage}
      fgColor={fgColor}
      logoOpacity={logoOpacity}
      qrStyle={qrStyle}
      ecLevel={ecLevel}
      size={size}
      eyeRadius={[
        {
          outer: 8,
          inner: 2,
        },
        {
          outer: 8,
          inner: 2,
        },
        {
          outer: 8,
          inner: 2,
        },
      ]}
    />
  )
}

export default AyrCode
